<template>
 <page>

   <head-nav title="language.add_photoalbum">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  <scroll-page>
    <page-padding>
     
      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}"></ui-input>

      <ui-htmlarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-htmlarea>
      <!--<ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>-->
      
      <!-- pick mobile variant -->
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getGalleryImages()" title="language.gallery" ></button-action>
     

      <!-- pick images desktop variant -->
      <button-file v-if="!isMobile" :active="computeUploadImagesLeft>0" :multiple="true" accept="image/jpeg,image/png" title="language.gallery" @change="getGalleryImagesBrowser"></button-file>


</page-padding>
      <upload-gallery :key="mediaKey" :medias="medias"/>
<page-padding>
     
     
    
      <ui-check :val="check.app" :disabled="true" v-on:selected="val=>{check.app = val}" title="language.place_in_schoolapp" />
      <ui-check :val="check.website" v-on:selected="val=>{check.website = val}" title="language.place_on_website" />
      <!--<ui-check :val="check.narrowcasting" v-on:selected="val=>{check.narrowcasting = val}" title="language.place_on_narrow" />-->
      <ui-check :val="check.pushnote" v-on:selected="val=>{check.pushnote = val}" title="language.important_pushnote" />

      <divider title=""/>
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
      
     </page-padding>
  </scroll-page> 
   </page>
</template>

<script>
/* present images in a scroll menu */


import { mapState } from 'vuex';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiCheck from '../components/UiCheck.vue'
import UiInput from '../components/UiInput.vue';
import UiHtmlarea from '../components/UiHtmlarea.vue';
import UploadGallery from '../components/uploadGallery/UploadGallery.vue';
import { imagePicker } from '../services/ImagePicker.js'
import { api } from '../services/Api';
import Page from '../pages/Page.vue';
import { modalService } from '../services/ModalService';
import i18n from "../language.js";
import { fileTransfer } from '../services/FileTransfer.js';
import { eventBus } from '../services/EventBus.js';
import Vue from 'vue';
import ScrollPage from '../components/ScrollPage.vue';
import Divider from '../components/dividers/Divider.vue';
import { history } from "../services/History.js";
import ButtonFile from '../components/buttons/ButtonFile.vue';
import { cordovaInit } from '../services/CordovaInit.js';
import { FILE_SIZE } from '../settings/FILE_SIZE.js';

export default {
  name: 'add-photoalbum-page',
  data:function(){
    return{
      id:this.$route.params.id, /* group id*/
      title:"",
      description:"",
      bb_description:"",
      buttonActive:true,
      maxImages:20,
      medias:[],
      mediaKey:0,
      group:{ name:"no-name" },
      check:{ // non persistent
        app:true,
        website:false,
        //narrowcasting:false,
        pushnote:false,
      },
      isMobile:cordovaInit.isMobile(),
    }
  },
  computed:{
    ...mapState([
       'groups','appSettings','user_schools',
       ]),
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"add_album_photo.php");
      },
      computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.add_photoalbum');
        }
      },
      computeUploadImagesLeft(){
        
        var imagesLeft=this.maxImages-this.medias.length;
        if(imagesLeft<0){ imagesLeft=0;}
        return imagesLeft;
      },
  },
  components: {
    ButtonActivate,
    ButtonAction,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiCheck,
    UploadGallery,
    Page,
    ScrollPage,
    Divider,
    ButtonFile,
    UiHtmlarea,
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
    isFormComplete(){

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }

      return true
    },
    getGalleryImages(){

      this.buttonActive=false;
      
       var args = {
        'selectMode': imagePicker.mediaType.IMAGE, //101=picker image and video , 100=image , 102=video
        'maxSelectCount': this.computeUploadImagesLeft, //default 40 (Optional)
        'maxSelectSize': FILE_SIZE.IMAGE, //180000000=180M (Optional) only android (15000000 15 mb)
      };
      

      imagePicker.getMedias(args).then( medias => {
        this.buttonActive=true;

        var c=0;
        medias.forEach(media=>{
          setTimeout(()=>{
            this.medias.push(media)
          },c*50);
          c++;
           
        })
        
      })

      
    },
    getGalleryImagesBrowser(e){
      
      this.buttonActive=false;

      imagePicker.fileListToMedias(e.target.files).then(result=>{
       
        var c=0;
        result.forEach(media=>{
          setTimeout(()=>{
            
           
            this.medias.push(media)
            
          },c*50);
          c++;
           
        })

        this.buttonActive=true;
      })

    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

      this.buttonActive=false;

      this.createAlbum();
     
    
    },
    createAlbum(){
      // first create album
      var payload={
        group_id:this.group ? this.group.id : 0,
        group_name:this.group ? this.group.name : "",
        text:this.bb_description,
        title:this.title,
        //app:this.check.app ? 1 : 0,
        website:this.check.website ? 1 : 0,
        //narrowcasting:this.check.narrowcasting ? 1 : 0,
      }
      
      
      this.$store.dispatch('add_album',payload).then(result=>{
       var album_id=result.data.album_id;
        // start uploading medias first item
       
        this.uploadNextFile(album_id,0);
      });
      
      

    },
    allUploadFinished(album_id){
        
       
      Vue.$toaster.toast("language.album_upload_succes");
       

       // send push note..
      this.sendPushNote(album_id);

       

      // reset form vars etc
      this.buttonActive=true;
        this.medias=[];
        this.title=""
        this.description="";


       this.back();

    },
    sendPushNote(album_id){

      var group_name=this.group ? this.group.name : this.$t('language.groeps_overstijgend');

      var payload={
        group_id:this.id,
        title:this.$t('language.pushnote_album_created'),
        message:group_name+":"+this.title,
        url:"/photoalbum/"+album_id+"/view",
        important:this.check.pushnote ? 1 : 0,
        type:"album",
      }

      this.$store.dispatch('send_pushnote',payload);
    },
    uploadNextFile(album_id,index){
     
      if(index>=this.medias.length){
        this.allUploadFinished(album_id);
        return;
      }
      var media=this.medias[index];
     // console.log("ul next:",media,index)
      var params={
        group_id:this.group ? this.group.id : 0,
        file_name:"none.jpg",
        album_id:album_id,
        exif_orientation:media.exifOrientation.toString(),
        sort:index,
        token:this.appSettings.token,
      }
      
      var payload={media}
      eventBus.$emit("MEDIA_UPLOAD_START",payload);
      
     
     fileTransfer.uploadFile(media.url,this.upload_path,params).then(()=>{
      
        var payload={media}
        // start animate out gallery image
        eventBus.$emit("MEDIA_UPLOAD_DONE",payload);
         index+=1;
       
         setTimeout(()=>{
          // allow some time for animaion to finish
           this.uploadNextFile(album_id,index);
        },350)
        
        
      },error=>{
        alert("filetransfer error: "+error)
        this.buttonActive=true;
      })
      
    },
    addListeners(){
      eventBus.$on('UPLOAD_GALLERY_LOADING_DONE',()=>{
        this.buttonActive=true;
      })
    },
    removeListeners(){
      eventBus.$off('UPLOAD_GALLERY_LOADING_DONE');
    }

  },
  beforeDestroy(){
    this.removeListeners();
  },
  mounted(){
    // get group by id
    this.group = this.groups.find(group => group.id === this.id);
    this.addListeners();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail{
  width:100%;
  height:auto;
}
</style>
